<template>
  <PerfectScrollbar class="AllPwaMobile">
    <div class="TopAllPwaMobileHeader">
      <div class="DollarSquareDollar">
        <VsxIcon iconName="DollarSquare" :size="32" :color="color" type="linear" />
        <p>{{ $t('investment.investment') }}</p>
      </div>
    </div>

    <div class="ShowSelectSearch">
      <label>{{ $t('investment.selectPanel') }}</label>
      <multiselect :placeholder="$t('investment.select')" v-model="value" :options="options" label="name" track-by="name"></multiselect>

     
    </div>

    <div v-if="value && value.value" class="ShowSelectSearch">
      <div class="investment-available-balance" :class="{ 'is-light': color === '#2E1977' }" aria-live="polite">
        <span>{{ $t('investment.systemBalance') }}</span>
        <strong v-if="walletsLoading">{{ $t('investment.loadingBalance') }}</strong>
        <strong v-else>{{ formatLimitAmount(planWalletBalance) }} {{ value.value.currency || value.value.currency_name }}</strong>
      </div>
    </div>
    <div class="investment-funds-breakdown-wrap">
      <WalletFundsBreakdown :wallets="userWalletUsers" :withdrawals="withdrawalRecords" />
    </div>

    <div v-if="value && value.value" style="margin-top: 30px !important;" class="ShowSelectSearch">
      <label>{{ $t('investment.enterAmount') }}</label>
      <input maxlength="30" style="font-family: sans-serif" @input="validateInput" class="InputX" type="text" placeholder="0" v-model="moneyDollar">
      <div class="ShowDollarName">{{ value?.value?.currency_name || value?.value?.currency || '—' }}</div>
      <div class="investment-amount-limits" :class="{ 'is-light': color === '#2E1977' }" role="group" :aria-label="$t('investment.amountLimits')">
        <div class="investment-amount-limit">
          <span class="investment-amount-limit__label">{{ $t('investment.minAmount') }}</span>
          <div class="investment-amount-limit__value-row">
            <strong class="investment-amount-limit__value">{{ formatLimitAmount(value.value.minimum) }}</strong>
            <span class="investment-amount-limit__currency">{{ value.value.currency || value.value.currency_name }}</span>
          </div>
        </div>
        <div class="investment-amount-limit">
          <span class="investment-amount-limit__label">{{ $t('investment.maxAmount') }}</span>
          <div class="investment-amount-limit__value-row">
            <strong class="investment-amount-limit__value">{{ formatLimitAmount(value.value.maximum) }}</strong>
            <span class="investment-amount-limit__currency">{{ value.value.currency || value.value.currency_name }}</span>
          </div>
        </div>
      </div>

      <div class="investment-coupon-box" :class="{ 'is-light': color === '#2E1977' }">
        <label class="investment-coupon-label" for="investment-coupon-code">{{ $t('investment.coupon.label') }}</label>
        <div class="investment-coupon-controls">
          <input
            id="investment-coupon-code"
            v-model.trim="couponCode"
            type="text"
            autocomplete="off"
            :placeholder="$t('investment.coupon.placeholder')"
            :disabled="couponApplyLoading"
          />
          <button type="button" :disabled="couponApplyLoading || !couponCode" @click="applyCoupon">
            {{ couponApplyLoading ? $t('investment.coupon.checking') : $t('investment.coupon.apply') }}
          </button>
        </div>
        <div v-if="appliedCoupon" class="investment-coupon-applied" role="status">
          <span>{{ $t('investment.coupon.applied', { amount: formatLimitAmount(appliedCoupon.amount), currency: appliedCoupon.currency }) }}</span>
          <button type="button" @click="removeCoupon">{{ $t('investment.coupon.remove') }}</button>
        </div>
        <div v-if="appliedCoupon && Number(moneyDollar) > 0" class="investment-coupon-summary">
          <div>
            <span>{{ $t('investment.coupon.walletAmount') }}</span>
            <strong>{{ formatLimitAmount(moneyDollar) }} {{ value.value.currency || value.value.currency_name }}</strong>
          </div>
          <div>
            <span>{{ $t('investment.coupon.bonus') }}</span>
            <strong>+{{ formatLimitAmount(appliedCoupon.amount) }} {{ appliedCoupon.currency }}</strong>
          </div>
          <div class="investment-coupon-total">
            <span>{{ $t('investment.coupon.totalInvestment') }}</span>
            <strong>{{ formatLimitAmount(totalInvestmentAmount) }} {{ value.value.currency || value.value.currency_name }}</strong>
          </div>
        </div>
      </div>
    </div>

    <div v-if="value && value.value" class="SelectStyleMarginTop">
      <div style="border: 1px solid rgba(255,0,0,0.2)" class="ChildSelectStyleMarginTop">
        <p style="color: #be5656">
          {{ $t('investment.endDate') }} : {{ endDate }}
        </p>
      </div>
      <div class="ChildSelectStyleMarginTop">
        <p>{{ $t('investment.startDate') }}: {{ startDate }}</p>
      </div>
    </div>

    <div class="ShowTitleAndThisStyle" :style="{ direction: $i18n.locale === 'en' ? 'ltr' : 'rtl', justifyContent: $i18n.locale === 'en' ? 'flex-start' : 'flex-end' }">
  
      <label class="container">
        <input v-model="CheckTrue" @change="handleTermsChange" type="checkbox">
        <div class="checkmark"></div>
      </label>

      <span>{{ $t('investment.iAccept') }}</span>
      <p>{{ $t('investment.termsAndConditions') }}</p>
      
    </div>

    <div @click="ClickTest" class="ButtonShowSelectSearch1">
      {{ $t('investment.activatePanel') }}
    </div>

    <vue-bottom-sheet v-if="value && value.value" ref="myBottomSheet">
      <PerfectScrollbar style="position: relative !important;" class="myBottomSheetV">
        <div
          id="investment-contract-content"
          ref="contractContent"
          class="investment-contract-document"
          :dir="$i18n.locale === 'fa' ? 'rtl' : 'ltr'"
        >
          <img class="investment-contract-watermark" src="@/assets/img/darkLP.png" alt="" aria-hidden="true">
          <div class="investment-contract-copy">
            <p>{{ $t('investment.contract.title') }}</p>
            <p class="investment-contract-text">{{ $t('investment.contract.intro', { startDate, nationalId: dataGet.nationalId, sex: dataGet.sex, fullName: dataGet.full_name, nationalCode: dataGet.nationalcode }) }}</p>

            <template v-if="dataGet.contract_number">
              <p class="investment-contract-text">{{ $t('investment.contract.contractNumber', { number: dataGet.contract_number }) }}</p>
            </template>

            <p>{{ $t('investment.contract.article1.title') }}</p>
            <p class="investment-contract-text">{{ $t('investment.contract.article1.content', { amount: formatLimitAmount(totalInvestmentAmount), currency: value.value.currency_name || value.value.currency }) }}</p>

            <p>{{ $t('investment.contract.article2.title') }}</p>
            <p class="investment-contract-text">{{ $t('investment.contract.article2.content', { startDate, endDate }) }}</p>

            <p>{{ $t('investment.contract.article3.title') }}</p>
            <p class="investment-contract-text">{{ $t('investment.contract.article3.content', { minInterest: formatInterestRate(value.value.interest_min), maxInterest: formatInterestRate(value.value.interest_max) }) }}</p>

            <p>{{ $t('investment.contract.article4.title') }}</p>
            <p class="investment-contract-text">{{ $t('investment.contract.article4.content') }}</p>

            <p>{{ $t('investment.contract.article5.title') }}</p>
            <p class="investment-contract-text">{{ $t('investment.contract.article5.content') }}</p>

            <h2>{{ $t('investment.contract.companyName') }}</h2>

            <img class="investment-contract-signature" src="/img/signature.jpg" alt="Contract signature">
          </div>

        </div>
        <button
          type="button"
          class="investment-contract-download"
          :disabled="isGeneratingPdf"
          @click="downloadContractPdf"
        >
          {{ isGeneratingPdf ? $t('investment.downloadingContract') : $t('investment.downloadContractPdf') }}
        </button>
        <div @click="BtnClickClose" class="ButtonShowSelectSearch14">{{ $t('investment.contract.close') }}</div>
      </PerfectScrollbar>
    </vue-bottom-sheet>

  </PerfectScrollbar>
</template>

<script>
import { PerfectScrollbar } from 'vue3-perfect-scrollbar';
import Multiselect from 'vue-multiselect';
import axios from "@/axios";
import { toast } from "vue3-toastify";
import moment from 'moment-jalaali';
import html2pdf from 'html2pdf.js';
import VueBottomSheet from "@webzlodimir/vue-bottom-sheet";
import "@webzlodimir/vue-bottom-sheet/dist/style.css";
import WalletFundsBreakdown from './WalletFundsBreakdown.vue';

export default {
  name: 'depositUser',
  components: {
    PerfectScrollbar,
    Multiselect,
    VueBottomSheet,
    WalletFundsBreakdown,
  },
  data() {
    return {
      clickBtn: 0,
      startDate: '',
      CheckTrue: false,
      endDate: '',
      color: localStorage.getItem('theme') === 'dark' ? '#BB86FC' : '#2E1977',
      planList: [], // مقداردهی اولیه به عنوان آرایه خالی
      moneyDollar: "",
      couponCode: '',
      appliedCoupon: null,
      couponApplyLoading: false,
      dataGet: {},
      value: { value: null },
      options: [],

      userWalletUsers: [],
      withdrawalRecords: [],
      userLis: {},
      walletsLoading: false,
      isGeneratingPdf: false,
    }
  },
  watch: {
    value(){
      this.dateModify();
      this.removeCoupon();
    },
    '$i18n.locale'() {
      this.$forceUpdate();
    }
  },
  computed: {
    totalInvestmentAmount() {
      return Number(this.moneyDollar || 0) + Number(this.appliedCoupon?.amount || 0);
    },
    planWalletBalance() {
      const currency = String(this.value?.value?.currency || '').trim().toUpperCase();
      if (!currency) return 0;

      return this.userWalletUsers
        .filter(item => String(item.currency_code || '').trim().toUpperCase() === currency)
        .reduce((total, wallet) => total + Number(wallet.available_balance ?? wallet.balance ?? 0), 0);
    }
  },
  methods: {
    async applyCoupon() {
      const code = String(this.couponCode || '').trim();
      if (!code) return;

      let user = {};
      try {
        user = JSON.parse(localStorage.getItem('user') || '{}');
      } catch (error) {
        user = {};
      }
      if (!user.id) return;

      this.couponApplyLoading = true;
      try {
        const response = await axios.post('/get-user-latest-discount', { user_id: user.id });
        const availableCoupons = Array.isArray(response.data?.discounts)
          ? response.data.discounts
          : (response.data?.discount ? [response.data.discount] : []);
        const coupon = availableCoupons.find(item => String(item.code).toUpperCase() === code.toUpperCase());

        if (!coupon) {
          this.appliedCoupon = null;
          toast(this.$t('investment.coupon.invalid'), {
            autoClose: 3000,
            position: 'top-right',
            type: 'error',
          });
          return;
        }

        const planCurrency = String(this.value?.value?.currency || '').toUpperCase();
        if (String(coupon.currency || '').toUpperCase() !== planCurrency) {
          this.appliedCoupon = null;
          toast(this.$t('investment.coupon.currencyMismatch'), {
            autoClose: 3000,
            position: 'top-right',
            type: 'error',
          });
          return;
        }

        this.appliedCoupon = coupon;
        this.couponCode = coupon.code;
        toast(this.$t('investment.coupon.appliedToast'), {
          autoClose: 2500,
          position: 'top-right',
          type: 'success',
        });
      } catch (error) {
        console.error('Error validating investment coupon:', error);
        toast(error.response?.data?.message || this.$t('investment.coupon.validationFailed'), {
          autoClose: 3000,
          position: 'top-right',
          type: 'error',
        });
      } finally {
        this.couponApplyLoading = false;
      }
    },

    removeCoupon() {
      this.appliedCoupon = null;
      this.couponCode = '';
    },

    handleTermsChange() {
      if (!this.CheckTrue) return;

      if (!this.value?.value) {
        this.CheckTrue = false;
        toast(this.$t('investment.errors.noPlan'), {
          autoClose: 3000,
          position: 'top-right',
          type: 'error',
        });
        return;
      }

      this.prepareContractPreview();
      this.$nextTick(() => this.$refs.myBottomSheet?.open());
    },
    prepareContractPreview() {
      let user = {};
      try {
        user = JSON.parse(localStorage.getItem('user') || '{}');
      } catch (error) {
        user = {};
      }

      this.dataGet = {
        full_name: user.full_name || user.name || '',
        nationalId: user.nationalId || user.national_id || '',
        sex: user.sex || '',
        nationalcode: user.nationalcode || user.national_code || user.nationalCode || '',
      };
    },
    async downloadContractPdf() {
      if (this.isGeneratingPdf) return;
      if (!this.moneyDollar) {
        toast(this.$t('investment.errors.noAmount'), {
          autoClose: 3000,
          position: 'top-right',
          type: 'error',
        });
        return;
      }

      const printWindow = window.open('', '_blank');
      if (!printWindow) {
        toast(this.$i18n.locale === 'fa'
          ? 'برای نمایش قرارداد، اجازه باز شدن پنجره جدید را فعال کنید.'
          : 'Allow pop-ups to open the contract preview.', {
          autoClose: 4000,
          position: 'top-right',
          type: 'error',
        });
        return;
      }

      this.prepareContractPreview();
      this.isGeneratingPdf = true;
      try {
        printWindow.document.open();
        printWindow.document.write('<!doctype html><html><head><meta charset="utf-8"><meta name="viewport" content="width=device-width, initial-scale=1"><title>Investment contract</title></head><body></body></html>');
        printWindow.document.close();
        this.$refs.myBottomSheet?.open();
        await this.$nextTick();
        await new Promise(resolve => setTimeout(resolve, 300));

        const contract = this.$refs.contractContent;
        if (!contract) throw new Error('Contract preview is unavailable');

        const contractImages = Array.from(contract.querySelectorAll('img'));
        await Promise.all(contractImages.map(image => {
          if (image.complete && image.naturalWidth > 0) return Promise.resolve();
          if (typeof image.decode === 'function') return image.decode();
          return new Promise((resolve, reject) => {
            image.onload = resolve;
            image.onerror = reject;
          });
        }));
        const embeddedImages = contractImages.map(image => {
          if (!image.naturalWidth || !image.naturalHeight) return image.src;
          const imageCanvas = document.createElement('canvas');
          imageCanvas.width = image.naturalWidth;
          imageCanvas.height = image.naturalHeight;
          const context = imageCanvas.getContext('2d');
          if (!context) return image.src;
          context.drawImage(image, 0, 0);
          return imageCanvas.toDataURL('image/png');
        });
        const watermarkIndex = contractImages.findIndex(image => image.classList.contains('investment-contract-watermark'));
        const watermarkDataUrl = embeddedImages[watermarkIndex];
        if (!watermarkDataUrl?.startsWith('data:image/')) {
          throw new Error('Contract watermark image could not be embedded');
        }

        const printDocument = printWindow.document;
        const baseElement = printDocument.createElement('base');
        baseElement.href = document.baseURI;
        printDocument.head.prepend(baseElement);
        Array.from(document.querySelectorAll('style, link[rel="stylesheet"]')).forEach(styleNode => {
          printDocument.head.appendChild(styleNode.cloneNode(true));
        });
        const printStyles = printDocument.createElement('style');
        printStyles.textContent = `
          html, body { min-height: 100%; margin: 0; }
          body { box-sizing: border-box; padding: 24px; background: #eeebf2; }
          #investment-contract-preview-status { width: 794px; max-width: 100%; margin: 0 auto 16px; color: #33264a; font: 14px/1.6 Arial, sans-serif; text-align: center; }
          #investment-contract-content { width: 794px !important; min-width: 794px !important; max-width: 794px !important; margin: 0 auto; box-shadow: 0 8px 30px rgba(28, 16, 42, .14); }
          @media print {
            body { padding: 0; background: #fff; }
            #investment-contract-preview-status { display: none; }
            #investment-contract-content { margin: 0; box-shadow: none; }
          }
        `;
        printDocument.head.appendChild(printStyles);
        const previewStatus = printDocument.createElement('div');
        previewStatus.id = 'investment-contract-preview-status';
        previewStatus.textContent = 'قرارداد در این صفحه نمایش داده می‌شود؛ فایل PDF پس از آماده‌سازی دانلود خواهد شد.';
        printDocument.body.appendChild(previewStatus);
        const printContract = contract.cloneNode(true);
        printContract.style.width = '794px';
        printContract.style.minWidth = '794px';
        printContract.style.maxWidth = '794px';
        printContract.style.margin = '0 auto';
        Array.from(printContract.querySelectorAll('img')).forEach((image, index) => {
          if (embeddedImages[index]) image.src = embeddedImages[index];
        });
        printDocument.body.appendChild(printContract);
        await Promise.all(Array.from(printContract.querySelectorAll('img')).map(image => (
          typeof image.decode === 'function' ? image.decode() : Promise.resolve()
        )));
        if (printDocument.fonts?.ready) await printDocument.fonts.ready;

        if (document.fonts?.load) {
          await document.fonts.load('15px iranyekan');
          await document.fonts.load('15px iranyekanB');
          await document.fonts.ready;
        }

        const pdfRenderWidth = 794;
        const pdfWorker = html2pdf()
          .set({
            margin: [8, 8, 8, 8],
            filename: `investment-contract-${this.value.value.id || 'preview'}.pdf`,
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: {
              scale: 2,
              width: pdfRenderWidth,
              windowWidth: pdfRenderWidth,
              useCORS: true,
              backgroundColor: '#ffffff',
              onclone: async clonedDocument => {
                const clonedContract = clonedDocument.getElementById('investment-contract-content');
                if (!clonedContract) return;
                clonedDocument.body.style.width = `${pdfRenderWidth}px`;
                clonedDocument.body.style.minWidth = `${pdfRenderWidth}px`;
                clonedContract.style.width = `${pdfRenderWidth}px`;
                clonedContract.style.minWidth = `${pdfRenderWidth}px`;
                clonedContract.style.maxWidth = `${pdfRenderWidth}px`;
                clonedContract.style.flex = 'none';
                clonedContract.style.maxHeight = 'none';
                clonedContract.style.height = 'auto';
                clonedContract.style.overflow = 'visible';
                clonedContract.style.boxShadow = 'none';
                clonedContract.style.fontFamily = "'iranyekan', Tahoma, sans-serif";
                clonedContract.style.direction = clonedContract.getAttribute('dir') || 'ltr';
                const clonedImages = Array.from(clonedContract.querySelectorAll('img'));
                const clonedWatermark = clonedContract.querySelector('.investment-contract-watermark');
                if (!clonedWatermark) throw new Error('Contract watermark is missing from the PDF clone');
                clonedWatermark.src = watermarkDataUrl;
                clonedImages.forEach((image, index) => {
                  if (image !== clonedWatermark && embeddedImages[index]) image.src = embeddedImages[index];
                });
                await Promise.all(clonedImages.map(image => (
                  typeof image.decode === 'function' ? image.decode() : Promise.resolve()
                )));
                if (!clonedWatermark.naturalWidth) throw new Error('Contract watermark failed to decode for PDF');
                let parent = clonedContract.parentElement;
                while (parent && parent !== clonedDocument.body) {
                  parent.style.maxHeight = 'none';
                  parent.style.height = 'auto';
                  parent.style.overflow = 'visible';
                  parent.style.transform = 'none';
                  parent = parent.parentElement;
                }
              },
            },
            jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
          })
          .from(printContract)
          .toCanvas();

        await pdfWorker.toPdf().save();
        const completedStatus = printDocument.getElementById('investment-contract-preview-status');
        if (completedStatus) completedStatus.textContent = 'PDF دانلود شد؛ نسخه HTML قرارداد در این صفحه باز است.';
      } catch (error) {
        console.error('Error generating investment contract PDF:', error);
        const previewStatus = printWindow.closed
          ? null
          : printWindow.document?.getElementById('investment-contract-preview-status');
        if (previewStatus) previewStatus.textContent = 'ساخت PDF انجام نشد؛ متن قرارداد در همین صفحه قابل مشاهده است.';
        toast(this.$t('investment.downloadContractFailed'), {
          autoClose: 3000,
          position: 'top-right',
          type: 'error',
        });
      } finally {
        this.isGeneratingPdf = false;
      }
    },
    ClickTest(){
      if (!this.value || this.value.value == null) {
        toast(this.$t('investment.errors.noPlan'), {
          autoClose: 3000,
          position: "top-right",
          type: "error",
        });
      } else if (this.moneyDollar == '') {
        toast(this.$t('investment.errors.noAmount'), {
          autoClose: 3000,
          position: "top-right",
          type: "error",
        });
      } else if (this.couponCode && !this.appliedCoupon) {
        toast(this.$t('investment.coupon.applyBeforeActivate'), {
          autoClose: 3000,
          position: "top-right",
          type: "error",
        });
      } else if (this.CheckTrue !== true) {
        toast(this.$t('investment.errors.termsNotAccepted'), {
          autoClose: 3000,
          position: "top-right",
          type: "error",
        });
      } else {
        this.calculateDates();
      }
    },
    BtnClickClose(){
      this.$refs.myBottomSheet.close();
    },
    validateInput(event) {
      const value = event.target.value;
      if (!/^\d*$/.test(value)) {
        event.target.value = value.replace(/[^\d]/g, '');
      }
    },
    loadTheme() {
      const savedTheme = localStorage.getItem('theme');
      this.color = savedTheme === "light" ? '#2E1977' : '#BB86FC';
    },
    async getPlan() {
      let attempts = 0;
      const maxAttempts = 10;
      const delay = 100;
      while (attempts < maxAttempts) {
        try {

          const response = await axios.get('/plan-get');
          this.planList = response.data;

          this.options = [];
          if (Array.isArray(response.data[0]) && response.data[0].length > 0) {
            // فقط پلن‌های نوع سرمایه‌گذاری
            response.data[0]
              .filter(p => (p.plan_type || 'investment') === 'investment')
              .forEach(plan => {
              const minimumValue = parseFloat(plan.minimum.trim());
              const maximumValue = parseFloat(plan.maximum.trim());
               if (!isNaN(minimumValue) && !isNaN(maximumValue)) {
                 this.options.push({
                   name: `(پلن ${plan.name}) ${this.formatInterestRate(plan.interest_min)}% الی ${this.formatInterestRate(plan.interest_max)}%`,
                   value: plan
                 });
               } else {
                 console.warn(`Invalid minimum or maximum value for plan: ${plan.name}`);
               }
            });
          }

          // Load balances for display; the investment itself selects its wallet by plan currency/network.
          await this.getUserWalletUsers()
          return;
        } catch (error) {
          if (error.response) {
            const errors = error.response.data.errors;
            const keys = Object.keys(errors);
            for (const key of keys) {
              toast(errors[key].join(', '), {
                autoClose: 3000,
                position: "top-right",
                type: "error",
              });
            }
            return;
          } else {
            console.log('111')
          }
        }

        attempts++;
        await new Promise(resolve => setTimeout(resolve, delay));
      }
    },
    dateModify(){
      const today = moment();
      const currentLocale = this.$i18n.locale; // Get current locale
      
      if (currentLocale === 'fa') {
        // Persian (Jalali) format
        this.startDate = today.format('jYYYY/jMM/jDD');
        const duration = this.value?.value?.duration || 0;
        const endDate = today.clone().add(duration, 'days');
        this.endDate = endDate.format('jYYYY/jMM/jDD');
      } else {
        // English (Gregorian) format
        this.startDate = today.format('YYYY/MM/DD');
        const duration = this.value?.value?.duration || 0;
        const endDate = today.clone().add(duration, 'days');
        this.endDate = endDate.format('YYYY/MM/DD');
      }
    },
    async calculateDates() {

      const userData = localStorage.getItem('user');
      if (userData) {
        this.userLis = JSON.parse(userData);
      }

      let attempts = 0;
      const maxAttempts = 10;
      const delay = 100;

      while (attempts < maxAttempts) {
        try {
          const response = await axios.post('/get-user-planet', {
            id: this.userLis.id,
            plan_id: this.value?.value?.id,
            amount: this.moneyDollar,
            coupon_code: this.appliedCoupon?.code || null,
          });

          if (response.data[0] == "error"){
            toast(response.data[1], {
              autoClose: 3000,
              position: "top-right",
              type: "error",
            });
            return;
          }

          if (response.data[0] == "success"){
            toast(this.$t('investment.activated'), {
              autoClose: 3000,
              position: 'top-right',
              type: 'success',
            });
            this.$router.push('/contracts').catch(error => {
              console.error('Error navigating to investments:', error);
            });
          }
          return;
        } catch (error) {
          console.error('Error fetching user planet data:', error); // نمایش خطا به‌طور دقیق‌تر
          if (error.response) {
            const errorData = error.response.data;
            const message = Array.isArray(errorData) ? errorData[1] : errorData?.message;
            toast(message || this.$t('investment.coupon.validationFailed'), {
              autoClose: 3000,
              position: 'top-right',
              type: 'error',
            });
            return;
          }
        }

        attempts++;
        await new Promise(resolve => setTimeout(resolve, delay));
      }
    },
    async getUserWalletUsers(){
      const userData = localStorage.getItem('user');
      if (userData) { this.userLis = JSON.parse(userData); }
      if (!this.userLis?.id) return;

      this.walletsLoading = true;
      try {
        const { data } = await axios.post('/get-wallet-users', { user_id: this.userLis.id })
        if (data && data.success) {
          this.userWalletUsers = Array.isArray(data.data) ? data.data : []
        }
      } catch(e){
        console.error('Failed to fetch investment wallet balance', e);
        this.userWalletUsers = [];
      } finally {
        this.walletsLoading = false;
      }
      try {
        const response = await axios.post('/withdraw-user', { user_id: this.userLis.id });
        this.withdrawalRecords = response.data?.[1]?.[0]?.data || [];
      } catch (error) {
        console.error('Failed to fetch withdrawal breakdown for investment page', error);
        this.withdrawalRecords = [];
      }
    },
    formatCurrency(amount) {
      const numericAmount = parseFloat(amount); // تبدیل به عدد
      if (isNaN(numericAmount)) {
        return '0.00'; // اگر مقدار عددی نبود
      }
      return numericAmount.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","); // فرمت‌دهی با کاما
    },
    formatLimitAmount(amount) {
      const numericAmount = Number(amount);
      if (!Number.isFinite(numericAmount)) return amount ?? '—';
      const locale = this.$i18n.locale === 'fa' ? 'fa-IR' : 'en-US';
      return new Intl.NumberFormat(locale, { maximumFractionDigits: 8 }).format(numericAmount);
    },
    formatInterestRate(rate) {
      const numericRate = Number(rate);
      if (!Number.isFinite(numericRate)) return rate ?? '0';
      const locale = this.$i18n.locale === 'fa' ? 'fa-IR' : 'en-US';
      return new Intl.NumberFormat(locale, { maximumFractionDigits: 4 }).format(numericRate);
    },
  },
  mounted() {
    this.getPlan();
    setInterval(() => {
      this.loadTheme();
    }, 100);
  }
}
</script>

<style scoped>
.investment-funds-breakdown-wrap {
  box-sizing: border-box;
  margin-inline: 24px;
}

@media (max-width: 360px) {
  .investment-funds-breakdown-wrap {
    margin-inline: 20px;
  }
}

.investment-contract-download {
  margin: auto;
  display: block;
  width: 90%;
  text-align: center;
  margin-top: 14px;
  padding: 12px 16px;
  border: 1px solid #bb86fc;
  border-radius: 8px;
  background: transparent;
  color: #bb86fc;
  cursor: pointer;
  font: inherit;
  font-weight: 600;
}

.investment-contract-download:disabled {
  cursor: wait;
  opacity: 0.65;
}

.investment-contract-document {
  box-sizing: border-box;
  position: relative;
  isolation: isolate;
  width: 100%;
  padding: 18px;
  background: #fff;
  color: #222;
  font-family: 'iranyekan', Tahoma, sans-serif;
  font-size: 15px;
  line-height: 1.8;
  text-align: start;
  white-space: normal;
  word-break: normal;
  overflow-wrap: break-word;
  unicode-bidi: plaintext;
}

.investment-contract-watermark {
  position: absolute;
  z-index: 0;
  top: 50%;
  left: 50%;
  width: 240px;
  max-width: 60%;
  height: auto;
  opacity: 0.22;
  pointer-events: none;
  transform: translate(-50%, -50%);
}

.investment-contract-copy {
  position: relative;
  z-index: 1;
}

.investment-contract-copy > p {
  display: block;
  margin: 0 0 8px;
  line-height: 1.9;
}

.investment-contract-copy > p:not(.investment-contract-text) {
  margin-top: 14px;
  margin-bottom: 6px;
  font-weight: 700;
}

.investment-contract-copy > p:first-child {
  margin-top: 0;
}

.investment-contract-text {
  white-space: normal;
  word-break: normal;
  overflow-wrap: break-word;
  text-align: start;
  unicode-bidi: plaintext;
  hyphens: none;
}

.investment-contract-signature {
  display: block;
  width: 180px;
  max-width: 100%;
  height: auto;
  margin-top: 12px;
}

.investment-amount-limits {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  margin-top: 14px;
  padding: 13px 15px;
  border: 1px solid rgba(187, 134, 252, 0.3);
  border-radius: 10px;
  background: #1b1723;
}

.investment-available-balance {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 12px;
  padding: 14px 16px;
  border: 1px solid rgba(187, 134, 252, 0.3);
  border-radius: 10px;
  background: #1b1723;
  color: #c9c2d2;
}

.investment-available-balance strong {
  direction: ltr;
  color: #bb86fc;
  font-size: 1.05rem;
  font-variant-numeric: tabular-nums;
  unicode-bidi: isolate;
}

.investment-available-balance.is-light {
  border-color: #e3d9f0;
  background: #f7f4fb;
  color: #5d536a;
}

.investment-available-balance.is-light strong {
  color: #311950;
}

.investment-coupon-box {
  display: grid;
  gap: 10px;
  margin-top: 14px;
  padding: 14px;
  border: 1px solid rgba(187, 134, 252, 0.3);
  border-radius: 10px;
  background: #1b1723;
}

.investment-coupon-label {
  color: #c9c2d2;
  font-size: 0.85rem;
  font-weight: 600;
}

.investment-coupon-controls {
  display: flex;
  gap: 8px;
}

.investment-coupon-controls input {
  flex: 1;
  min-width: 0;
  padding: 10px 12px;
  border: 1px solid rgba(187, 134, 252, 0.3);
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.18);
  color: inherit;
  font: inherit;
}

.investment-coupon-controls button,
.investment-coupon-applied button {
  padding: 9px 13px;
  border: 1px solid #bb86fc;
  border-radius: 8px;
  background: #bb86fc;
  color: #211333;
  font: inherit;
  font-weight: 700;
  cursor: pointer;
}

.investment-coupon-controls button:disabled {
  cursor: wait;
  opacity: 0.6;
}

.investment-coupon-applied,
.investment-coupon-summary > div {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  color: #e5d9f3;
  font-size: 0.85rem;
}

.investment-coupon-applied {
  color: #72d3b1;
}

.investment-coupon-applied button {
  padding: 5px 9px;
  background: transparent;
  color: inherit;
}

.investment-coupon-summary {
  display: grid;
  gap: 8px;
  padding-top: 10px;
  border-top: 1px solid rgba(187, 134, 252, 0.2);
}

.investment-coupon-summary strong {
  direction: ltr;
  text-align: end;
  unicode-bidi: isolate;
}

.investment-coupon-total {
  padding-top: 8px;
  border-top: 1px solid rgba(187, 134, 252, 0.2);
  color: #bb86fc !important;
  font-weight: 700;
}

.investment-coupon-box.is-light {
  border-color: #e3d9f0;
  background: #f7f4fb;
}

.investment-coupon-box.is-light .investment-coupon-label,
.investment-coupon-box.is-light .investment-coupon-applied,
.investment-coupon-box.is-light .investment-coupon-summary > div {
  color: #5d536a;
}

.investment-coupon-box.is-light .investment-coupon-total {
  color: #311950 !important;
}

.investment-coupon-box.is-light .investment-coupon-controls input {
  border-color: #e3d9f0;
  background: #fff;
  color: #211333;
}

.investment-amount-limit {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 6px;
  padding-inline: 10px;
}

.investment-amount-limit + .investment-amount-limit {
  border-inline-start: 1px solid rgba(187, 134, 252, 0.24);
}

.investment-amount-limit__label {
  color: #c9c2d2;
  font-size: 0.78rem;
  font-weight: 500;
}

.investment-amount-limit__value-row {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 5px;
}

.investment-amount-limit__value {
  color: #bb86fc;
  direction: ltr;
  font-size: 1.05rem;
  font-variant-numeric: tabular-nums;
  font-weight: 700;
  overflow-wrap: anywhere;
  unicode-bidi: isolate;
}

.investment-amount-limit__currency {
  color: #c9c2d2;
  direction: ltr;
  font-size: 0.76rem;
  unicode-bidi: isolate;
}

.investment-amount-limits.is-light {
  border-color: #e3d9f0;
  background: #f7f4fb;
}

.investment-amount-limits.is-light .investment-amount-limit + .investment-amount-limit {
  border-color: #e3d9f0;
}

.investment-amount-limits.is-light .investment-amount-limit__label,
.investment-amount-limits.is-light .investment-amount-limit__currency {
  color: #5d536a;
}

.investment-amount-limits.is-light .investment-amount-limit__value {
  color: #311950;
}

@media (max-width: 360px) {
  .investment-amount-limits {
    grid-template-columns: minmax(0, 1fr);
    gap: 10px;
  }

  .investment-amount-limit {
    padding-inline: 2px;
  }

  .investment-amount-limit + .investment-amount-limit {
    padding-top: 10px;
    border-top: 1px solid rgba(187, 134, 252, 0.24);
    border-inline-start: 0;
  }

  .investment-amount-limits.is-light .investment-amount-limit + .investment-amount-limit {
    border-top-color: #e3d9f0;
  }
}
</style>
